import './App.css';
import React from "react";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';

import UpdateStatusMasehtot from "./SiumShas/userStatus/updateStatusMasehtot";
import AddUser from "./SiumShas/niulSium/addEditUser/masehtot/addUser";
import NewSium from "./SiumShas/newSium/newSium";
import EditSium from "./SiumShas/newSium/editSium";
import Welcome from "./welcome";
import EditUser from "./SiumShas/niulSium/addEditUser/masehtot/editUser";
import DisplaySium from "./SiumShas/displaySium/displaySium";
import SiumStatus from "./SiumShas/niulSium/siumStatus/siumStatus";
import UpdateStatusDapim from "./SiumShas/userStatus/updateStatusDapim";
import DisplaySiumDapim from "./SiumShas/displaySium/displaySiumDapim";
import EditUserD from "./SiumShas/niulSium/addEditUser/dapim/editUserD";
import LomdimLogin from "./SiumShas/userStatus/lomdimLogin";
import SiumimManager from "./siumimManager/siumimManager";
import Mipui from "./admin/Mipui";
import NewSiumAher from "./siumAher/newSium/newSiumAher";
import EditSiumAher from "./siumAher/newSium/editSiumAher";
import SiumAherStatus from "./siumAher/niulSium/siumAherStatus";
import AddUserAher from "./siumAher/niulSium/addEditUser/addUserAher";
import EditUserAher from "./siumAher/niulSium/addEditUser/editUserAher";
import UserStatusAher from "./siumAher/userStatus/userStatusAher";
import DisplaySiumAher from "./siumAher/displaySium/displaySiumAher";
import LomdimLoginAher from "./siumAher/userStatus/lomdimLoginAher";
import AdminSiumViewer from "./admin/AdminSiumViewer";

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

function App() {
    const viewport = document.querySelector('meta[name="viewport"]');
    if ( viewport ) {
        viewport.content = 'initial-scale=1';
        viewport.content = 'width=device-width';
    }
    document.title = 'סיום הש"ס: לימוד תורני מחולק';
  return (
      <Router>
          <div>
              <Routes>
                  <Route path="/updateStatus/:userId" element={<UpdateStatusMasehtot/>} />
                  <Route path="/editUserD/:userId" element={<EditUserD/>} />
                  <Route path="/updateStatusDapim/:userId" element={<UpdateStatusDapim/>} />
                  <Route path="/addUser/:siumId" element={<AddUser/>} />
                  <Route path="/niulSium/:siumId/siumStatus" element={<SiumStatus/>} />
                  <Route path="/niulSium/:siumId/editSium" element={<EditSium/>} />
                  <Route path="/niulSium/editUser/:userId" element={<EditUser/>} />
                  <Route path="/niulSium/editUserD/:userId" element={<EditUserD/>} />
                  <Route path="/displaySium/:displayId" element={<DisplaySium/>} />
                  <Route path="/displaySiumDapim/:displayId" element={<DisplaySiumDapim/>} />
                  <Route path="/lomdimLogin/:siumId" element={<LomdimLogin/>} />
                  <Route path="/newSium" element={<NewSium/>}/>
                  <Route path="/mySiumim/:siumId" element={<SiumimManager/>}/>
                  <Route path="/mySiumim" element={<SiumimManager/>}/>
                  <Route path="/newSiumAher" element={<NewSiumAher/>}/>
                  <Route path="/niulSiumAher/:siumId/editSium" element={<EditSiumAher/>}/>
                  <Route path="/niulSiumAher/:siumId/siumStatus" element={<SiumAherStatus/>}/>
                  <Route path="/addUserAher/:siumId" element={<AddUserAher/>}/>
                  <Route path="/editUserAher/:userId" element={<EditUserAher/>}/>
                  <Route path="/userStatusAher/:userId" element={<UserStatusAher/>}/>
                  <Route path="/displaySiumAher/:displayId" element={<DisplaySiumAher/>}/>
                  <Route path="/lomdimLoginAher/:siumId" element={<LomdimLoginAher/>}/>
                  <Route path="/mipui/:mipuiId" element={<Mipui/>}/>
                  <Route path="/admin/mipui" element={<Mipui/>}/>
                  <Route path="/admin/siumim" element={<AdminSiumViewer/>}/>
                  <Route path="*" element={<Welcome/>}/>
              </Routes>
          </div>
      </Router>
  );
}

export default App;
